var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("reporting_channel.protocol_number"),
                    "label-for": "protocol"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "protocol",
                      value: _vm._.get(_vm.requestForm, "form.protocol_number"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("reporting_channel.created_at"),
                    "label-for": "created_at"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "created_at",
                      value: _vm._.get(
                        _vm.requestForm,
                        "form.created_date_formatted"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "print:hidden content-center", attrs: { md: "3" } },
            [
              _c("NavigationOriginPopup", {
                attrs: { navigationField: _vm.navigationField }
              })
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "print:hidden content-center", attrs: { md: "3" } },
            [
              _c("ProtocolQueryHistoryPopup", {
                attrs: {
                  protocol_number: _vm._.get(
                    _vm.requestForm,
                    "form.protocol_number"
                  ),
                  type: "reporting-channel"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { attrs: { md: "12" } },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("reporting_channel.institution_unity"),
                    "label-for": "institution_unity"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto h-full",
                      attrs: { id: "institution_unity", readonly: "" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._.get(_vm.requestForm, "form.legal_entity_name")
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("reporting_channel.form.field05"),
                    "label-for": "field05"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                      class: _vm.configClassTextField(
                        _vm._.get(_vm.requestForm, "form.area")
                      ),
                      attrs: { id: "field05", readonly: "" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._.get(_vm.requestForm, "form.area")) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-card",
        { attrs: { title: _vm.$t("reporting_channel.sub_title") } },
        [
          _c(
            "b-row",
            { staticClass: "m-0" },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 px-2 mx-auto align-items-center",
                  attrs: { sm: "12", md: "8", lg: "8" }
                },
                [
                  _vm.isIdentify
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.form.field01_01"
                                ),
                                "label-for": "field01_01"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto",
                                  class: _vm.configClassTextField(
                                    _vm._.get(
                                      _vm.requestForm,
                                      "form.data.form_data.person.name"
                                    )
                                  ),
                                  attrs: { id: "field01_01", readonly: "" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.requestForm,
                                          "form.data.form_data.person.name"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.form.field01_02"
                                ),
                                "label-for": "field01_02"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto",
                                  class: _vm.configClassTextField(
                                    _vm._.get(
                                      _vm.requestForm,
                                      "form.data.form_data.person.document"
                                    )
                                  ),
                                  attrs: { id: "field01_02", readonly: "" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.requestForm,
                                          "form.data.form_data.person.document"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.form.field01_03"
                                ),
                                "label-for": "field01_03"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto",
                                  class: _vm.configClassTextField(
                                    _vm._.get(
                                      _vm.requestForm,
                                      "form.data.form_data.person.email"
                                    )
                                  ),
                                  attrs: { id: "field01_03", readonly: "" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.requestForm,
                                          "form.data.form_data.person.email"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.form.field01_04"
                                ),
                                "label-for": "field01_04"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto",
                                  class: _vm.configClassTextField(
                                    _vm._.get(
                                      _vm.requestForm,
                                      "form.data.form_data.person.phone"
                                    )
                                  ),
                                  attrs: { id: "field01_04", readonly: "" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.requestForm,
                                          "form.data.form_data.person.phone"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field02"),
                        "label-for": "field02"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line  overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm.customerRelationship
                          ),
                          attrs: { id: "field02", readonly: "" }
                        },
                        [_vm._v(" " + _vm._s(_vm.customerRelationship) + " ")]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field03"),
                        "label-for": "field03"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(_vm.typeReporting),
                          attrs: { id: "field03", readonly: "" }
                        },
                        [_vm._v(" " + _vm._s(_vm.typeReporting) + " ")]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field06"),
                        "label-for": "field06"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(_vm.knowFact),
                          attrs: { id: "field06", readonly: "" }
                        },
                        [_vm._v(" " + _vm._s(_vm.knowFact) + " ")]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field07"),
                        "label-for": "field07"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.statusOfReport.name"
                            )
                          ),
                          attrs: { id: "field07", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.statusOfReport.name"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field08"),
                        "label-for": "field08"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.whatReport"
                            )
                          ),
                          attrs: { id: "field08", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.whatReport"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field09"),
                        "label-for": "field09"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.keepsHappening"
                            )
                          ),
                          attrs: { id: "field09", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.keepsHappening"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field10"),
                        "label-for": "field10"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.whenAndWho"
                            )
                          ),
                          attrs: { id: "field10", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.whenAndWho"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field11"),
                        "label-for": "field11"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.otherPeople"
                            )
                          ),
                          attrs: { id: "field11", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.otherPeople"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field12"),
                        "label-for": "field12"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.thereEvidence"
                            )
                          ),
                          attrs: { id: "field12", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.thereEvidence"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field13"),
                        "label-for": "field13"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.siteProfile"
                            )
                          ),
                          attrs: { id: "field13", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.siteProfile"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field14"),
                        "label-for": "field14"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.whyReporting"
                            )
                          ),
                          attrs: { id: "field14", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.whyReporting"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field15"),
                        "label-for": "field15"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.howInvestigate"
                            )
                          ),
                          attrs: { id: "field15", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.howInvestigate"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field16"),
                        "label-for": "field16"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.employeesAware"
                            )
                          ),
                          attrs: { id: "field16", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.employeesAware"
                                )
                                  ? _vm.$t("yes")
                                  : _vm.$t("no")
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("reporting_channel.form.field17"),
                        "label-for": "field17"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "form-control break-all whitespace-pre overflow-x-auto whitespace-pre-line overflow-y-auto",
                          class: _vm.configClassTextField(
                            _vm._.get(
                              _vm.requestForm,
                              "form.data.form_data.financialValue"
                            )
                          ),
                          attrs: { id: "field17", readonly: "" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._.get(
                                  _vm.requestForm,
                                  "form.data.form_data.financialValue"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c("media-list", {
                    attrs: {
                      medias: _vm.files,
                      "show-delete": false,
                      "action-on-click": true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c("h5", { staticClass: "mt-2 mb-0" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.title || _vm.$t("reporting_channel.handling")) +
                    " "
                )
              ]),
              _c("vs-divider")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("reporting_channel.severity_level"),
                    "label-for": "severity_level"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "severity_level",
                      value: _vm.severityLevelDisplay,
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("reporting_channel.status"),
                    "label-for": "status"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "status",
                      value: _vm._.get(_vm.requestForm, "status_str"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.showHistory
            ? _c(
                "b-col",
                { staticClass: "print:hidden", attrs: { lg: "8" } },
                [
                  _c("HandlingHistoryPopup", {
                    attrs: {
                      id: _vm.id,
                      serviceDelegate: _vm.services.handling
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }